import script from "./RequestFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestFilter.vue?vue&type=script&setup=true&lang=js"

import "./RequestFilter.vue?vue&type=style&index=0&id=2854bd32&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2854bd32"]])

export default __exports__